type PageHeaderProps = {
  children: React.ReactNode;
};

const PageContent: React.FunctionComponent<PageHeaderProps> = (props) => {
  return (
    <>
      <div className='content d-flex flex-column overflow-hidden flex-grow-1 py-3'>{props.children}</div>
    </>
  );
};

export default PageContent;
